import { render, staticRenderFns } from "./PatientTab.vue?vue&type=template&id=536e9c05&scoped=true&"
import script from "./PatientTab.vue?vue&type=script&lang=js&"
export * from "./PatientTab.vue?vue&type=script&lang=js&"
import style0 from "./PatientTab.vue?vue&type=style&index=0&id=536e9c05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e9c05",
  null
  
)

export default component.exports